export const translations = {
	'Datasource single graph': {
		en: 'Datasource graph',
		no: 'Datakilde graf',
	},
	'General': {
		en: 'General',
		no: 'Generelt',
	},
	'Datasources': {
		en: 'Datasources',
		no: 'Datakilder',
	},
	'Datasource': {
		en: 'Datasource',
		no: 'Datakilde',
	},
	'Datasource row': {
		en: 'Datasource row',
		no: 'Datakilde rad',
	},
	'Time column': {
		en: 'Time column',
		no: 'Tidskolonne',
	},
	'Metric row': {
		en: 'Metric row',
		no: 'Metrikkrad',
	},
	'Color type': {
		en: 'Color type',
		no: 'Fargetype',
	},
	'Gradient direction': {
		en: 'Gradient direction',
		no: 'Gradientretning',
	},
	'Start color': {
		en: 'Start color',
		no: 'Startfarge',
	},
	'End color': {
		en: 'End color',
		no: 'Sluttfarge',
	},
	'Decimal Numbers': {
		en: 'Decimal numbers',
		no: 'Desimalnummer',
	},
};
